import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentGenerationService {
  constructor(public configService: ConfigService, private httpClient: HttpClient) {}

  public generateContractDocument(
    quoteRequestId: number,
    actionedByUserId: string,
    customerEmail: string,
    customerName: string,
    outputFormat: string,
    downloadDocument = false,
    emailDocument = false,
    preview = false
  ): Observable<any> {
    const path = this.configService.getApiPath(`documentGeneration/generate`);
    const body = {
      QuoteRequestId: quoteRequestId,
      OutputFormat: outputFormat,
      ActionedByUserId: actionedByUserId,
      CustomerEmail: customerEmail,
      CustomerName: customerName,
      DownloadDocument: downloadDocument,
      EmailDocument: emailDocument,
      Preview: preview,
    };

    if (downloadDocument) {
      return this.httpClient.post<Blob>(path, body, { responseType: 'blob' as 'json' });
    } else {
      return this.httpClient.post<any>(path, body);
    }
  }
}
